import { Injectable } from '@angular/core';
import { CustodiaRemunerada, CustodiaRemuneradaFaq, CustodiaRemuneradaTerm } from './model/custodia-remunerada.model';
import { CustodiaRemuneradaDataService } from './custodia-remunerada-data.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CustodiaRemuneradaMockDataService implements CustodiaRemuneradaDataService{
  getCustodiaRemunerada(): Observable<CustodiaRemunerada> {
    return new Observable<CustodiaRemunerada>(sub=>{
      sub.next(this.getCustodia())
    });
  }
  
  private term: CustodiaRemuneradaTerm = {
    nome: "Termo de contratação",
    conteudo: `
    <p class="text-mrb-sm">TERMO DE CONTRATAÇÃO DOS SERVIÇOS DE CUSTÓDIA REMUNERADA E OUTRAS AVENÇAS</p>
    <p class="text-mrb-sm">Este Termo de Contratação dos Serviços de Custódia Remunerada e Outras Avenças (“Termo”) é celebrado entre, de um lado,
     a ITAÚ CORRETORA DE VALORES S.A., com sede na Avenida Brigadeiro Faria Lima, nº 3500, 3º andar, parte, na Cidade de São Paulo, Estado de São Paulo, CNPJ/MF 
     n.º 61.194.353/0001-64 (“ITAÚ CORRETORA”); e o CLIENTE, já qualificado na Ficha Cadastral
     Para Intermediação de Operações ("CLIENTE", e quando referido em conjunto com a ITAÚ CORRETORA, "Partes" e, isoladamente, "Parte").</p>
    `,
  };

  private faq: CustodiaRemuneradaFaq = {
    contentFooter: `Para conferir todas as regras de contratação e ativação do serviço de
    Custódia Remunerada, entre em contato com o seu assessor de investimentos
    ou acesse: www.itau.com.br`,
    faq: [
      {
        id: 1,
        pergunta: "Quais são os custos da custódia remunerada?",
        resposta:
          "Para alugar suas ações, a Itaú Corretora cobra uma taxa de 30% sobre a operação.\n\nNa ponta doadora (quem disponibiliza seus ativos para aluguel), a remuneração do aluguel será tributada pelo Imposto de Renda retido na fonte, conforme tabela regressiva abaixo:\n\nI – 22,5% em aplicações com prazo de até 180 dias;\n\nII – 20% em aplicações com prazo de 181 dias até 360 dias;\n\nIII – 17,5% em aplicações com prazo de 361 dias até 720 dias;\n\nIV – 15% em aplicações com prazo acima de 720 dias.",
      },
      {
        id: 2,
        pergunta:
          "Vou continuar recebendo os dividendos pagos pelos emissores dos ativos?",
        resposta:
          "Sim. Mesmo alugando suas ações, você continuará recebendo os proventos eventualmente pagos, como dividendos e juros sobre capital próprio.",
      },
    ],
  };


  getTerm(): CustodiaRemuneradaTerm {
    return this.term;
  }

  getCustodia():CustodiaRemunerada{
    let custodia : CustodiaRemunerada = {};
    custodia.faq = this.getFaq();
    custodia.termo = this.getTerm();
    return custodia;
  }

  setTerm(term: CustodiaRemuneradaTerm): void {
    this.term = term;
  }

  getFaq(): CustodiaRemuneradaFaq {
    return this.faq;
  }

  setFaq(faq: CustodiaRemuneradaFaq): void {
    this.faq = faq;
  }
}